"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../diagram/model");
var CLASS_NAME = 'ontodia-edit-form';
var EditEntityForm = /** @class */ (function (_super) {
    tslib_1.__extends(EditEntityForm, _super);
    function EditEntityForm(props) {
        var _this = _super.call(this, props) || this;
        _this.renderProperty = function (key, values) {
            var view = _this.props.view;
            var property = view.model.getProperty(key);
            var label = model_1.formatLocalizedLabel(key, property.label, view.getLanguage());
            return (React.createElement("div", { key: key, className: CLASS_NAME + "__form-row" },
                React.createElement("label", null,
                    label,
                    values.map(function (value, index) { return (React.createElement("input", { key: index, className: 'ontodia-form-control', defaultValue: value.text })); }))));
        };
        _this.onChangeLabel = function (e) {
            var target = e.target;
            var labels = target.value.length > 0 ? [{ text: target.value, lang: '' }] : [];
            _this.setState({ elementModel: tslib_1.__assign({}, _this.state.elementModel, { label: { values: labels } }) });
        };
        _this.state = { elementModel: props.entity };
        return _this;
    }
    EditEntityForm.prototype.renderProperties = function () {
        var _this = this;
        var properties = this.props.entity.properties;
        return (React.createElement("div", null, Object.keys(properties).map(function (key) {
            var values = properties[key].values;
            return _this.renderProperty(key, values);
        })));
    };
    EditEntityForm.prototype.renderType = function () {
        var view = this.props.view;
        var elementModel = this.state.elementModel;
        var label = view.getElementTypeString(elementModel);
        return (React.createElement("label", null,
            "Type",
            React.createElement("input", { className: 'ontodia-form-control', value: label, disabled: true })));
    };
    EditEntityForm.prototype.renderLabel = function () {
        var view = this.props.view;
        var labels = this.state.elementModel.label.values;
        var label = labels.length > 0 ? model_1.chooseLocalizedText(labels, view.getLanguage()).text : '';
        return (React.createElement("label", null,
            "Label",
            React.createElement("input", { className: 'ontodia-form-control', value: label, onChange: this.onChangeLabel })));
    };
    EditEntityForm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__body" },
                React.createElement("div", { className: CLASS_NAME + "__form-row" }, this.renderType()),
                React.createElement("div", { className: CLASS_NAME + "__form-row" }, this.renderLabel()),
                this.renderProperties()),
            React.createElement("div", { className: CLASS_NAME + "__controls" },
                React.createElement("button", { className: "ontodia-btn ontodia-btn-success " + CLASS_NAME + "__apply-button", onClick: function () { return _this.props.onApply(_this.state.elementModel); } }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    };
    return EditEntityForm;
}(React.Component));
exports.EditEntityForm = EditEntityForm;
